import axios from 'axios'

const getGuestData = (list = 'guest') => {
  return new Promise((resolve, reject) => {
    axios
      .get('https://app.yanibasimdakaratay.com/api/hobi-bahce/misafir', {
        headers: {
          Authorization: JSON.parse(localStorage.getItem('token')),
        },
        params: {
          list: list,
        },
      })
      .then((res) => {
        resolve(res.data?.list)
      })
  })
}

// TC Kimlik No doğrulama
const isValidTC = (tc) => {
  if (!/^[1-9][0-9]{10}$/.test(tc)) return false
  const digits = tc.split('').map(Number)
  const sumOdd = digits[0] + digits[2] + digits[4] + digits[6] + digits[8]
  const sumEven = digits[1] + digits[3] + digits[5] + digits[7]
  const digit10 = (sumOdd * 7 - sumEven) % 10
  const digit11 = digits.slice(0, 10).reduce((a, b) => a + b, 0) % 10
  return digit10 === digits[9] && digit11 === digits[10]
}

// Doğum tarihi doğrulama (gg/aa/yyyy)
const isValidDate = (dateStr) => {
  if (!dateStr || dateStr.length !== 10) return false
  const parts = dateStr.split('/')
  if (parts.length !== 3) return false
  const day = parseInt(parts[0], 10)
  const month = parseInt(parts[1], 10)
  const year = parseInt(parts[2], 10)
  const date = new Date(year, month - 1, day)
  return (
    date.getDate() === day &&
    date.getMonth() === month - 1 &&
    date.getFullYear() === year &&
    year >= 1900 &&
    year <= new Date().getFullYear()
  )
}

// Telefon doğrulama (10 hane, sadece rakam)
const isValidPhone = (phone) => {
  const clean = phone.replace(/[^0-9]/g, '')
  return clean.length === 10
}

export { getGuestData, isValidTC, isValidDate, isValidPhone }
